/*
 * @Author: cgh
 * @Date: 2022-08-02 15:57:03
 * @LastEditors: DQL
 * @LastEditTime: 2022-10-24 18:28:04
 * @Description: 签章管理
 */

const bgglRoutes = {
  path: 'bggl',
  name: 'xfpgBggl',
  component: { template: '<router-view></router-view>' },
  children: [
    {
      path: 'dscbg',
      name: 'xfpgdsc',
      component: () => import(/* webpackChunkName: "xfpgdsc" */ '@/features/xfaqpg/bggl/list.vue'),
      meta: {
        navtabTitle: '待生成报告',
        isCache: true,
        ignoreDiff: [],
        isSecondary: false
      }
    },
    {
      path: 'dqz',
      name: 'xfpgdqz',
      component: () => import(/* webpackChunkName: "xfpgdqz" */ '@/features/xfaqpg/bggl/list.vue'),
      meta: {
        navtabTitle: '待签章报告',
        isCache: true,
        ignoreDiff: [],
        isSecondary: false
      }
    },
    {
      path: 'yqz',
      name: 'xfpgyqz',
      component: () => import(/* webpackChunkName: "xfpgyqz" */ '@/features/xfaqpg/bggl/list.vue'),
      meta: {
        navtabTitle: '已签章报告',
        isCache: true,
        ignoreDiff: [],
        isSecondary: false
      }
    },
    {
      path: 'dgz',
      name: 'xfpgdgz',
      component: () => import(/* webpackChunkName: "xfpgdgz" */ '@/features/xfaqpg/bggl/list.vue'),
      meta: {
        navtabTitle: '待盖章报告',
        isCache: true,
        ignoreDiff: [],
        isSecondary: false,
        menuElements: [
          { elementCode: 'pgxm_gz', elementName: '盖章' }
        ]
      }
    },
    {
      path: 'ygz',
      name: 'xfpgygz',
      component: () => import(/* webpackChunkName: "xfpgygz" */ '@/features/xfaqpg/bggl/list.vue'),
      meta: {
        navtabTitle: '已盖章报告',
        isCache: true,
        ignoreDiff: [],
        isSecondary: false
      }
    },
    // {
    //   path: 'xgsqbg',
    //   name: 'xfpgxgsqbg',
    //   component: () => import(/* webpackChunkName: "xfpgdgz" */ '@/features/xfaqpg/bggl/list.vue'),
    //   meta: {
    //     navtabTitle: '修改申请报告',
    //     isCache: true,
    //     ignoreDiff: [],
    //     isSecondary: false
    //   }
    // },
    {
      path: 'bgtsgl',
      name: 'xfpgbgts',
      component: () => import(/* webpackChunkName: "xfpgdgz" */ '@/features/xfaqpg/bggl/bgtsList.vue'),
      meta: {
        navtabTitle: '报告推送管理',
        isCache: true,
        ignoreDiff: [],
        isSecondary: false
      }
    },
    {
      path: 'sybg',
      name: 'xfpgsybg',
      component: () => import(/* webpackChunkName: "xfpgdgz" */ '@/features/xfaqpg/bggl/list.vue'),
      meta: {
        navtabTitle: '所有报告',
        isCache: true,
        ignoreDiff: [],
        isSecondary: false,
        menuElements: [
          { elementCode: 'pgxmManage_search', elementName: '查询' },
          { elementCode: 'pgxm_scbg_ls', elementName: '生成临时报告' },
          { elementCode: 'pgxm_scbg', elementName: '生成报告' },
          { elementCode: 'pgxm_cxpg', elementName: '重新评估' },
          { elementCode: 'pgxm_sqxg', elementName: '申请修改' },
          { elementCode: 'pgxm_qz', elementName: '签章' },
          { elementCode: 'pgxm_gz', elementName: '盖章' }
        ]
      }
    }
  ]
};

export default bgglRoutes;
